/** Decisively pages the adapter copy points to, by their place in the app's navigation. */
export const decisivelyPages = {
  fileProcessingTest: { trail: ["Build", "File processing", "Test"], to: "/build/file-processing?fileProcessingTab=test" },
  orgModels: { trail: ["Monitor", "Contacts", "Org models"], to: "/monitor/contacts/org-models" },
  events: { trail: ["Monitor", "Events"], to: "/monitor/events" },
  files: { trail: ["Monitor", "Files"], to: "/monitor/files" },
  adminSettings: { trail: ["Admin", "Settings"], to: "/admin/settings" },
} as const;

export type DecisivelyPage = keyof typeof decisivelyPages;

const TRAIL_SEPARATOR = " → ";

/**
 * A Markdown link to a Decisively page, which adapter Markdown shows as a breadcrumb link. In `.md` content write the
 * same thing by hand: `[Build → File processing → Test](/build/file-processing?fileProcessingTab=test)`.
 */
export const pageLink = (page: DecisivelyPage): string => `[${pageTrail(page)}](${decisivelyPages[page].to})`;

/** A page's breadcrumb trail as link text, for linking somewhere more specific on the page than `pageLink` does. */
export const pageTrail = (page: DecisivelyPage): string => decisivelyPages[page].trail.join(TRAIL_SEPARATOR);

/** A link's text as a breadcrumb trail, when it's written as one (`Build → File processing`). */
export const parsePageTrail = (text: string): string[] | undefined => {
  const trail = text.split("→").map((part) => part.trim());
  return trail.length > 1 && trail.every(Boolean) ? trail : undefined;
};
